const tokenUserInfo = process.env.VUE_APP_COOKIE_AUTH_UI;

import auth from "@/auth/authService";

export default {
  isUserLoggedIn: () => {
    return $cookies.get(tokenUserInfo) && auth.isAuthenticated();
  },
  userInfo: () => {
    if ($cookies.isKey(tokenUserInfo) && auth.isAuthenticated()) {
      return $cookies.get(tokenUserInfo);
    } else {
      return {};
    }
  },
  loginGroup: ''
};
